module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-bb.73097bed.png";